<div title class="text-[48px] pt-[20px] font-bold text-center flex place-content-center mx-[18px] text-primary italic">
    <img class="h-[250px]" [src]="'../assets/logoAuth.png'" />
</div>

<!-- <div class="mx-auto w-[300px]" *transloco="let t">
    <std-select (onChangeValue)="changeTypePlan($event)" customLabel="label-input" customClassContainerElement="max-h-[250px] overflow-y-scroll custom-scrollbar" customClassContaier="border-primary custom-select" [currentValue]="{label:t('annual'),value:'A'}" [data]="[
{label:t('monthly'),value:'M'},
{label:t('annual'),value:'A'}

    ]"></std-select>
</div> -->

<div class="flex flex-wrap place-content-center gap-[40px] p-[40px]">
    @for (plan of plans; track $index) {
        <div class="bg-[#F6F4F9] py-[30px] px-[40px] rounded-[30px] w-[440px] text-primary cursor-pointer"
        [ngClass]="{'border-[2px] border-[#7A6F9B]': $index == selectedPlan}"
        (click)="selectedPlan = $index;subscribeToPlan(plan.id)">
        <div class="text-title font-semibold">{{plan.name}}</div>
        <div class="text-medium mt-[10px]">{{plan.description}}</div>
        @for (planDesc of plan.descriptions; track $index) { <div class="flex">


            @if(planDesc.enable){<svg xmlns="http://www.w3.org/2000/svg" width="26" height="26" viewBox="0 0 26 26"
                fill="none">
                <path d="M21.125 6.5L9.75 19.5L4.875 14.625" stroke="#7A6F9B" stroke-width="2.5" stroke-linecap="round"
                    stroke-linejoin="round" />
            </svg>}
            @if(!planDesc.enable){ <svg xmlns="http://www.w3.org/2000/svg" width="26" height="26" viewBox="0 0 38 37"
                fill="none">
                <path d="M13.7156 13.2131L24.0571 23.5545M24.0571 13.2131L13.7156 23.5545" stroke="#7A6F9B"
                    stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
            </svg>}
            <div>{{planDesc.description}}</div>
        </div>}

        <div class="text-title text-right mt-2">€ {{plan.price}}/{{plan.duration == 1 ? 'mese': (plan.duration == 12 ? 'anno' : (plan.duration + ' mesi'))}} + IVA</div>

    </div>}
</div>
@if(selectedPlan >= 0){<div class="flex place-content-center">
    <std-button (click)="goToPay()"
        buttonClass="bg-primary focus:bg-primary hover:bg-primary text-tertiary text-large w-[240px]">Conferma</std-button>
</div>}